import { createTheme } from '@mui/material/styles';
import { TOKENS } from './tokens';

/**
 * Tema MUI dell'app per variante: 'light', 'dark' o 'oled' (scuro con neri assoluti).
 * In modalità scura sfondi e testi vengono dai colori delle pagine V2.
 */
export function buildAppTheme(variant = 'light') {
  const t = TOKENS[variant] || TOKENS.light;
  const mode = variant === 'light' ? 'light' : 'dark';
  const oled = variant === 'oled';
  return createTheme({
    // Variante letta da chi ha bisogno dei valori dei colori (es. grafici SVG)
    rtVariant: variant,
    typography: {
      fontFamily: "'Archivo', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    },
    palette: {
      mode,
      success: {
        // Verde più chiaro del default MUI (per accenti / Monthly Manager View)
        main: '#5dbe63',
        light: '#8fd894',
        dark: '#3f9d46',
        contrastText: '#ffffff',
      },
      ...(mode === 'dark'
        ? {
            background: { default: t.page, paper: t.paper },
            text: { primary: t.ink, secondary: t.muted },
            divider: t.line,
          }
        : {}),
    },
    // OLED: niente schiarimento delle superfici in rilievo (menu, finestre) e un bordo al posto dell'ombra
    ...(oled
      ? {
          components: {
            MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
            MuiPopover: { styleOverrides: { paper: { border: `1px solid ${t.line}` } } },
            MuiMenu: { styleOverrides: { paper: { border: `1px solid ${t.line}` } } },
            MuiDialog: { styleOverrides: { paper: { border: `1px solid ${t.line}` } } },
            MuiDrawer: { styleOverrides: { paperAnchorRight: { borderLeft: `1px solid ${t.line}` } } },
          },
        }
      : {}),
  });
}
